module.exports = "static/assets/2501d1b87cf04e00cc3a623fa8b5d95c.svg";